/** Račun narudžbe koja nastaje iz zahtjeva za zamjenu.
 *
 *  Artikli ulaze u narudžbu po punoj cijeni, a ono što je kupac ranije platio
 *  se oduzima jednom `fee_line` stavkom. Rezultat je da `total` narudžbe bude
 *  tačno onoliko koliko kurir naplaćuje — vidi `src/services/shipping.ts:377`. */

export type ExchangeTotalsInput = {
  /** Zbir stavki po punoj cijeni. */
  subtotal: number;
  /** Popust od kupona, već sveden na iznos u KM. */
  couponDiscount: number;
  /** Iznos koji kupac plaća za robu; 0 kad je zamjena bez doplate. */
  priceDifference: number;
  /** Cijena odabrane metode dostave. */
  shippingCost: number;
  /** Da li se dostava naplaćuje kupcu. */
  shippingCharged: boolean;
};

export type ExchangeTotals = {
  /** Iznos `fee_line` stavke. Tačno 0 znači da se linija uopšte ne šalje. */
  fee: number;
  /** Naziv `fee_line` stavke; prazan string kad je `fee` nula. */
  feeLabel: string;
  /** Iznos `shipping_line` stavke — 0 kad se dostava ne naplaćuje. */
  shippingTotal: number;
  /** Ono što kupac plaća, tj. `total` narudžbe. */
  total: number;
};

/** Ispod pola centa nema smisla slati zasebnu stavku. */
const EPSILON = 0.005;

function num(value: number): number {
  return Number.isFinite(value) ? value : 0;
}

function round2(value: number): number {
  return Math.round(value * 100) / 100;
}

export function computeExchangeTotals(input: ExchangeTotalsInput): ExchangeTotals {
  const subtotal = num(input.subtotal);
  const couponDiscount = num(input.couponDiscount);
  const priceDifference = num(input.priceDifference);
  const shippingTotal = input.shippingCharged ? round2(num(input.shippingCost)) : 0;

  const rawFee = priceDifference - (subtotal - couponDiscount);
  const fee = Math.abs(rawFee) < EPSILON ? 0 : round2(rawFee);
  const feeLabel = fee === 0 ? "" : fee < 0 ? "Zamjena — plaćeno ranije" : "Doplata";

  return { fee, feeLabel, shippingTotal, total: round2(priceDifference + shippingTotal) };
}
